import { URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const member = {
    get: {
        // @Url /v1/members/base-address/{luidx} 
        // @Description 기본주소지 조회인데 사용안함
        baseAddress: async(params) => {
            return await http.get(
                `${URLs.members}/base-address/${params.luidx}`
            )
        },
        // @Url /v1/members/address/{luidx}
        address: async(params) => {
            return await http.get(
                `${URLs.members}/address/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/car-info/{luidx}
        carInfo: async(params) => {
            return await http.get(
                `${URLs.members}/car-info/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/career/{luidx}
        career: async(params) => {
            return await http.get(
                `${URLs.members}/career/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/education/{luidx}
        education: async(params) => {
            return await http.get(
                `${URLs.members}/education/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/license/{luidx}
        license: async(params) => {
            return await http.get(
                `${URLs.members}/license/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/profile/{luidx}
        profile: async(params) => {
            return await http.get(
                `${URLs.members}/profile/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/confirm-info/{luidx}
        confirmInfo: async(params) => {
            return await http.get(
                `${URLs.members}/confirm-info/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/my-commute
        myCommute: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/my-commute`, {
                    params: params
                }
            )
        },
        // @Url /v1/mypage/distresses/{luidx}
        distresses: async(params) => {
            return await http.get(
                `${URLs.mypage}/distresses/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/mypage/{cbidx}/use-vacation/{luidx}
        useVacation: async(params) => {
            return await http.get(
                `${URLs.mypage}/${params.cbidx}/use-vacation/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/mypage/{luidx}/required-file-list
        requiredFileList: async(params) => {
            return await http.get(
                `${URLs.mypage}/${params.luidx}/required-file-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/mypage/file-box/{luidx}
        fileBox: async(params) => {
            return await http.get(
                `${URLs.mypage}/file-box/${params.luidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/my-commute-calendar
        myCommuteList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/my-commute-calendar`, {
                    params: params
                }
            )
        },
        // @Url /v1/mypage/payslip-detail
        payslipDetail: async(params) => {
            return await http.get(
                `${URLs.mypage}/payslip-detail`, {
                    params: params
                },
            )
        },
        // @Url /v1/mypage/{cbidx}/staff-commute-calendar
        myCommuteCalendar: async(params) => {
            return await http.get(
                `${URLs.mypage}/${params.cbidx}/staff-commute-calendar`, {
                    params: params
                }
            )
        }
    },
    post: {
        // @Url /v1/members/base-address/{luidx}/{idx}
        defaultAddress: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/base-address/${params.luidx}/${params.idx}`, formData
            )
        },
        // @Url /v1/members/address/{luidx}
        address: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/address/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/address/{luidx}/{idx}
        updateAddress: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/address/${params.luidx}/${params.idx}`, formData
            )
        },
        // @Url /v1/members/reset-login-pwd
        resetLoginPwd: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/reset-login-pwd`, formData
            )
        },
        // @Url /v1/members/email/{luidx}
        email: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/email/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/phone-no/reset/{luidx}
        phoneNoReset: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/phone-no/reset/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/{luidx}/base
        base: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/${params.luidx}/base`, formData
            )
        },
        // @Url /v1/members/car-info/{luidx}
        carInfo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/car-info/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/car-info/{luidx}/{idx}
        updateCarInfo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/car-info/${params.luidx}/${params.idx}`, formData
            )
        },
        // @Url /v1/members/career/{luidx}
        career: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/career/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/career/{luidx}/{idx}
        updateCareer: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/career/${params.luidx}/${params.idx}`, formData
            )
        },
        // @Url /v1/members/license/{luidx}
        license: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/license/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/license/{luidx}/{idx}
        updateLicense: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/license/${params.luidx}/${params.idx}`, formData
            )
        },
        // @Url /v1/members/education/{luidx}
        education: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/education/${params.luidx}`, formData
            )
        },
        // @Url /v1/members/education/{luidx}/{idx}
        updateEducation: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/education/${params.luidx}/${params.idx}`, formData
            )
        },
        // @Url /v1/members/profile/{luidx}/branch
        profileBranch: async(params) => {
            return await http.post(
                `${URLs.members}/profile/${params.luidx}/branch`, params
            )
        },
        // @Url /v1/members/profile/{luidx}
        profile: async(params) => {
            return await http.post(
                `${URLs.members}/profile/${params.luidx}`, params
            )
        },
        // @Url /v1/members/usage-job-plan/{luidx}
        usageJobPlan: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/usage-job-plan/${params.luidx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/new-staff-commute
        staffCommute: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/new-staff-commute`,
                params, {
                    params: params
                }
            )
        },
        // @Url /v1/mypage/distresses/{luidx}
        distresses: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.mypage}/distresses/${params.luidx}`, formData
            )
        },
        // @Url /v1/mypage/file-box/{luidx}
        fileBox: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.mypage}/file-box/${params.luidx}`, formData
            )
        },
        // @Url /v1/mypage/submit-file/{luidx}/copy/{idx}
        copyFile: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.mypage}/submit-file/${params.luidx}/copy/${params.idx}`, formData
            )
        },
        // @Url /v1/members/confirm/{luidx}
        confirm: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/confirm/${params.luidx}`,
                formData
            )
        }
    },
    delete: {
        // @Url /v1/members/address/{luidx}/{idx}
        address: async(params) => {
            return await http.delete(
                `${URLs.members}/address/${params.luidx}/${params.idx}`
            )
        },
        // @Url /v1/members/car-info/{luidx}/{idx}
        carInfo: async(params) => {
            return await http.delete(
                `${URLs.members}/car-info/${params.luidx}/${params.idx}`
            )
        },
        // @Url /v1/members/career/{luidx}/{idx}
        career: async(params) => {
            return await http.delete(
                `${URLs.members}/career/${params.luidx}/${params.idx}`
            )
        },
        // @Url /v1/members/license/{luidx}/{idx}
        license: async(params) => {
            return await http.delete(
                `${URLs.members}/license/${params.luidx}/${params.idx}`
            )
        },
        // @Url /v1/members/education/{luidx}/{idx}
        education: async(params) => {
            return await http.delete(
                `${URLs.members}/education/${params.luidx}/${params.idx}`
            )
        },
        // @Url /v1/members/profile/{luidx}/branch/{idx}
        profileBranch: async(params) => {
            return await http.delete(
                `${URLs.members}/profile/${params.luidx}/branch/${params.idx}`
            )
        },
        // @Url /v1/mypage/distresses/{luidx}/{idx}
        distresses: async(params) => {
            return await http.delete(
                `${URLs.mypage}/distresses/${params.luidx}/${params.idx}`, {
                    params: {
                        uuid: params.uuid
                    }
                }
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/members.js